//@ts-nocheck
import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { BasePagingResponse, BaseResponse } from "../_types";

export interface IGetMerchantAccountHistory {
  fullName: string;
  name: string;
  surname: string;
  username: string;
  email: string;
  phoneNumber: string;
  hashPassword: string;
  password: string | null;
  tryCount: number;
  systemPassword: boolean;
  memberId: number;
  merchantId: number;
  merchantName?: string;
  userType: string;
  id: number;
  status: "BLOCKED" | "ACTIVE" | "PASSIVE" | null;
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate: string;
  updateUserId: number;
  deleteDate: string | null;
  deleteUserId: number;
  roles: [
    {
      key: number;
      value: string;
      description: string;
    }
  ];
}

export type GetUserListResponse = BasePagingResponse<Array<IGetMerchantAccountHistory>>;

export type GetMerchantAccountHistoryListRequest = {
  page: number;
  pageSize: number;
  orderByDesc: boolean;
  orderBy: string;
  merchantId: number;
  [key: string]: string | number | boolean | undefined;
};

async function getMerchantAccountHistory(
  data: GetMerchantAccountHistoryListRequest
): Promise<GetUserListResponse> {
  try {
    var result = (await axiosInstance.post("/MerchantCurrentBalanceMovement/GetMerchantAccountHistory", data)).data;
    result.data.result = result.data.result.map((item) => {
      return { ...item, currencyDesc: item.currency };
    });
    return result;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantAccountHistory() {
  return useMutation<GetUserListResponse, Error, GetMerchantAccountHistoryListRequest>(
    (variables) => getMerchantAccountHistory(variables)
  );
}
